import { mergeStyles } from "@fluentui/react";
import { NavigationType } from "@configuration/SpaConfiguration";

export const getFooterStyles = (pageNavigationVisible: boolean, navigationType: NavigationType): string => {
    return mergeStyles({
        marginTop: 30,
        textAlign: 'right',
        padding: 10,
        'span': {
            fontWeight: 600,
            color: 'grey',
        }
    });
};